export default Object.freeze({
    USER_TYPE_STAFF: "STAFF",
    USER_TYPE_CUSTOMER: "CUSTOMER",
    USER_TYPE_SERVICE_ACCOUNT: "SERVICE_ACCOUNT",
    USER_STATUS_ACTIVE: "ACTIVE",
    USER_STATUS_DELETED: "DELETED",

    DEVICE_STATUS_REGISTERED: "REGISTERED",
    DEVICE_STATUS_ACTIVE: "ACTIVE",
    DEVICE_STATUS_SUSPENDED: "SUSPENDED",
    DEVICE_STATUS_RETIRED: "RETIRED",
    DEVICE_STATUS_NONACTIVE: "NON-ACTIVE",

    DEVICE_SUPPORT_STATUS_SUPPORTED: "SUPPORTED",
    DEVICE_SUPPORT_STATUS_NEARING_END: "NEARING_END",
    DEVICE_SUPPORT_STATUS_UNSUPPORTED: "UNSUPPORTED",
    DEVICE_SUPPORT_STATUS_CRITICAL_ONLY: "CRITICAL_ONLY",
    
    RELEASE_TYPE_HANDSET: "handset",
    RELEASE_TYPE_SERVER: "server",
    RELEASE_TYPE_OPTIONS: Object.freeze([
        { text: "Handset", value: "handset" },
        { text: "Server", value: "server" },
    ]),
    ACTIVE_STATUS: "active",
    INACTIVE_STATUS: "inactive",
    STATUS_OPTIONS: Object.freeze([
        { text: "ACTIVE", value: "active" },
        { text: "INACTIVE", value: "inactive" },
    ]),

    PRODUCT_SERVICE_TYPES: [
        { id: 5, name: "BookClub - UK",    regex: "\\w+-BOOKCLUB-\\w+-\\w+" },
        { id: 3, name: "Phone - UK",       regex: "\\w+-RPHONE.-\\w+-\\w+" },
        { id: 1, name: "Pocket - UK",      regex: "\\w+-POCKET.-\\w+-\\w+" },
        { id: 6, name: "Pocket Plus - UK", regex: "\\w+-POCKEP.-\\w+-\\w+" },
    ],
    
    PRODUCT_PAYMENT_TYPES: [
        { name: "Monthly", regex: "\\w+-\\w+-M\\w+-\\w+" },
        { name: "Upfront", regex: "\\w+-\\w+-U\\w+-\\w+" },
    ],
    
    PRODUCT_TAX_TYPES: [
        { name: "Taxed",    regex: "\\w+-\\w+T-\\w+-\\w+" },
        { name: "Exempted", regex: "\\w+-\\w+X-\\w+-\\w+" },
    ],
    PRODUCT_ADDON_TYPES: [
        { name: "Network", regex: "\\w+-NETWORK-\\w+-\\w+", labelRegex: "\\d+(?:GB|MB|TB)" },
        { name: "Charger", regex: "\\w+-CHARGER-\\w+-\\w+" },
    ],
})
